import {
  threeStar,
  emptyString,
  EMPTY_ARRAY_LENGTH,
  questionTypeConstants,
  CONSUMER_RESPONSES_LABELS,
} from "../../constants";
import ReadonlyStarRating from "./readonlyStarRating";
import ReadOnlyTextarea from "../shared/readOnlyTextarea";

const { QUESTION_PREFIX } = CONSUMER_RESPONSES_LABELS;

const SubmittedSurveyComponent = ({ questionJson }) => {
  if (
    !Array.isArray(questionJson) ||
    questionJson.length === EMPTY_ARRAY_LENGTH
  ) {
    return null;
  }

  return questionJson.map((question, index) => (
    <div
      className="mt-3 shadow rounded"
      key={question.QuestionOrder}
      aria-label="question"
    >
      <div className="bg-white pt-3 pb-1 rounded-top">
        <h6 className="fw-bold ps-3 ps-md-5">
          {QUESTION_PREFIX}
          {index + 1}
        </h6>
      </div>
      <p className="pt-3 ps-3 ps-md-5 bold-6">{question.QuestionText}</p>
      <div className="bg-white rounded-bottom">
        {/* Options selected on the bases of question types */}
        {question.QuestionTypeId ===
          questionTypeConstants.STAR_RANKING_ID && (
          <div className="px-md-5 px-3 py-3 ">
            <ReadonlyStarRating initialValue={question.Answer} />
            {question.Answer <= threeStar &&
            question.StarRatingTextBox &&
            question.StarRatingTextBox.trim() !== emptyString ? (
              <div className="pt-3" aria-label="textBox">
                <ReadOnlyTextarea value={question.StarRatingTextBox} />
              </div>
            ) : (
              <></>
            )}
          </div>
        )}
        {question.QuestionTypeId === questionTypeConstants.TEXTBOX_ID && (
          <div className="px-md-5 px-3 py-3">
            <ReadOnlyTextarea value={question.Answer} />
          </div>
        )}
      </div>
    </div>
  ));
};

export default SubmittedSurveyComponent;
